import { HELP_URL } from '../../../../config';
import {
	SUBSCRIPTION_NPL,
	SUBSCRIPTION_RESELLER_FAQ,
	SUBSCRIPTION_RESELLER_FAQ_LINK,
	SUBSCRIPTION_NPL_SUSPENDED,
	SUBSCRIPTION_RESELLER,
	SUBSCRIPTION_RESELLER_AWAIT,
	SUBSCRIPTION_RESELLER_INFORMATION,
	SUBSCRIPTION_RTL_VOUCHER,
	SUBSCRIPTION_RTL_VOUCHER_INFORMATION,
} from '../../../../constants/Copy';
import { RESELLERS } from '../../../../constants/ResellersAndPartners';
import { friendlyDate } from '../../../../helpers/datetime';
import React, { Fragment } from 'react';

const ResellerCopy = ({ subscription, user }) => {
	const reseller = getReseller(subscription);
	if (!reseller) return getAwaitResellerCopy();

	if (user.isActiveNPLSubscription) {
		return getNplCopy(user.isConvertedToTermedUser, reseller.displayName, subscription.endDate);
	} else {
		if (!reseller) {
			return getRTLXLCopy();
		}

		return getDefaultResellerCopy(reseller);
	}
};

export default ResellerCopy;

function getAwaitResellerCopy() {
	return <>{SUBSCRIPTION_RESELLER_AWAIT}</>;
}

function getDefaultResellerCopy(reseller) {
	let resellerCopy = `${SUBSCRIPTION_RESELLER}${reseller.displayName}.`;

	if (!reseller.omitContactReseller) {
		resellerCopy += ` ${SUBSCRIPTION_RESELLER_INFORMATION}${reseller.displayName}.`;
	}

	return <>{resellerCopy}</>;
}

function getRTLXLCopy() {
	return (
		<>
			{SUBSCRIPTION_RTL_VOUCHER}. {SUBSCRIPTION_RTL_VOUCHER_INFORMATION}.
		</>
	);
}

function getReseller(subscription) {
	if (!subscription || !(subscription.reseller || subscription.trustedParty)) return null;
	const resellerId = subscription.reseller || subscription.trustedParty;
	return RESELLERS.find((reseller) => reseller.id === resellerId);
}

function getNplCopy(isConvertedToTermedUser, displayName, endDate) {
	const friendlyEndDate = friendlyDate(endDate);
	let copy = endDate ? SUBSCRIPTION_NPL.replace('{end_date}', friendlyEndDate) : '';
	const npl_faq = `${HELP_URL}/article/ik-heb-videoland-cadeau-gekregen-via-de-nationale-postcode-loterij-npl`;

	if (isConvertedToTermedUser) {
		copy = `${copy} ${SUBSCRIPTION_NPL_SUSPENDED.replace('{end_date}', friendlyEndDate)}`;
	}

	return (
		<Fragment>
			<p>{copy}</p>
			<p>
				{SUBSCRIPTION_RESELLER_FAQ}
				<a href={npl_faq} target="_blank" rel="noopener" title={SUBSCRIPTION_RESELLER_FAQ_LINK}>
					{' '}
					{SUBSCRIPTION_RESELLER_FAQ_LINK}
				</a>
				.
			</p>
		</Fragment>
	);
}
